module.exports = __webpack_public_path__ + "img/favorite-4.0fd61893.svg";